// src/contexts/FriendsContext.js

import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import { useQuery, gql } from "@apollo/client";

const FriendsContext = createContext();

export const useFriends = () => useContext(FriendsContext);

const GET_MY_FRIENDS = gql`
  query GetMyFriends {
    myFriends {
      id
      username
      avatarKey
      avatarUrl
    }
  }
`;

export const FriendsProvider = ({ children }) => {
  const [friends, setFriends] = useState([]);

  const currentUser = JSON.parse(localStorage.getItem("user"));
  const userId = currentUser?.id;

  const { data, loading, error, refetch } = useQuery(GET_MY_FRIENDS, {
    skip: !userId,
    fetchPolicy: "no-cache", // avoid cache-based corruption
  });

  useEffect(() => {
    if (data?.myFriends?.length) {
      const hydrated = data.myFriends.filter((f) => f.avatarUrl);
      if (hydrated.length === 0) return;

      const isSame = JSON.stringify(friends) === JSON.stringify(hydrated);
      if (!isSame) {
        setFriends(hydrated);
      }
    }
  }, [data]);

  const value = useMemo(
    () => ({ friends, loading, error, refetch }),
    [friends, loading, error, refetch]
  );

  return (
    <FriendsContext.Provider value={value}>{children}</FriendsContext.Provider>
  );
};
